// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import HomeOutlined from '/Users/xubing/WORK/workspace/architect-cloud/architect-ui/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/HomeOutlined';
import VideoCameraOutlined from '/Users/xubing/WORK/workspace/architect-cloud/architect-ui/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/VideoCameraOutlined';
export default { HomeOutlined, VideoCameraOutlined };
